import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=28ea8958&"
import script from "./AssetList.vue?vue&type=script&lang=js&"
export * from "./AssetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports